import React, {
  useState,
  useContext
} from "react";
import {
  withRouter
} from "react-router";
import {
  makeStyles
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";
import AlertMui from "../core/AlertMui";
import ModalMui from "../core/ModalMui";
import TermsOfUseMui from "../core/TermsOfUseMui";

import AlertContext from "../../context/alert/alertContext";
import ModalContext from "../../context/modal/modalContext";
import AuthContext from "../../context/authentication/authContext";
import useMediaQuery from "../../hooks/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    height: "553px",
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    marginTop: "20px",
    marginLeft: "20px",
  },
  typography: {
    padding: theme.spacing(3),
    fontSize: "22px",
  },
  form: {
    marginTop: theme.spacing(1),
  },
  contentSubmit: {
    margin: theme.spacing(3, 0, 2),
    textAlign: "center",
  },
}));

const ChangePassword = (props) => {
  const alertContext = useContext(AlertContext);
  const {
    alert,
    showAlert /* message */
  } = alertContext;
  const authContext = useContext(AuthContext);
  const { user, closeSession, hasToChange } = authContext;
  const modalContext = useContext(ModalContext);
  const { modalShow, showModal, closeModal } = modalContext;
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  /* useEffect(() => {
     if (message) {
      showAlert(message.msg, message.category);
    }
  }, [message]) */

  const {
    changePassword
  } = authContext;
  const [changePasswordForm, setChangePasswordForm] = useState({
    currentPassword: "",
    newPassword: "",
    repeatPassword: "",
  });

  const [loading, setLoading] = useState(false);

  const {
    currentPassword,
    newPassword,
    repeatPassword
  } = changePasswordForm;

  const classes = useStyles();
  const isMobile = useMediaQuery("max-width", 600);

  //console.log(window.location.href);
  const startIndex = window.location.href.indexOf('?');
  if (startIndex > 0) {
    const hasToShowTermsOfUse = window.location.href.substring(startIndex + '?show-terms-use='.length);
    if (hasToShowTermsOfUse === '1') {
      if (modalTitle !== "Términos de Uso") {
        setModalTitle("Términos de Uso");
        setModalContent(
          <TermsOfUseMui closeModal={closeModal} hasToAccept={true}></TermsOfUseMui>
        );
        showModal();
      }

    }
  }


  const onChange = (e) => {
    setChangePasswordForm({
      ...changePasswordForm,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    //validate empty fields
    if (
      currentPassword.trim() === "" ||
      newPassword.trim() === "" ||
      repeatPassword.trim() === ""
    ) {
      showAlert("Todos los campos son obligatorios.", "warning");
      setLoading(false);
      return;
    }

    if (newPassword !== repeatPassword) {
      showAlert("Por favor ingrese las 2 contraseñas iguales", "warning");
      setLoading(false);
      return;
    }

    try {
      const response = await changePassword({
        currentPassword,
        newPassword
      });

      if (response.responseCode === 0) {
        showAlert("La contraseña ha sido cambiada.", "success");
        setTimeout(() => {
          localStorage.clear();
          closeSession();
          window.location.href = "/auth/login";
        }, 2000);
      } else {
        showAlert(response.responseMessage, "error");
      }
    } catch (error) {
      showAlert("Ha ocurrido un error inesperado", "error");
    }

    setLoading(false);
  };

  return (
    <div className={classes.root}>
      <ModalMui
        modalShow={modalShow}
        showModal={showModal}
        closeModal={closeModal}
        modalTitle={modalTitle}
      >
        {modalContent}
      </ModalMui>
      <Grid item xs={12}>
        <Grid item xs={12} >
          <Typography className={classes.typography}> Cambiar Contraseña </Typography>
          <Paper className={classes.paper} >
            <form className={
              classes.form
            }
              style={{
                width: !isMobile ? "30%" : "100%"
              }
              }
              noValidate onSubmit={
                onSubmit
              } >
              <TextField margin="normal"
                fullWidth id="currentPassword"
                label="CONTRASEÑA ACTUAL"
                name="currentPassword"
                autoComplete="currentPassword"
                type="password"
                autoFocus InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }
                InputProps={
                  {
                    style: {
                      fontSize: "14px"
                    },
                    startAdornment: (<InputAdornment position="start" >
                      < LockOutlinedIcon style={
                        {
                          color: "#12b1ee",
                        }
                      }
                      /> </InputAdornment >
                    ),
                  }
                }
                value={
                  currentPassword
                }
                onChange={
                  onChange
                }
              /> <TextField margin="normal"
                fullWidth name="newPassword"
                label="CONTRASEÑA NUEVA"
                type="password"
                id="newPassword"
                autoComplete="newPassword"
                style={
                  {
                    fontSize: "14px"
                  }
                }
                InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }
                InputProps={
                  {
                    style: {
                      fontSize: "14px"
                    },
                    startAdornment: (<InputAdornment position="start" >
                      <LockOutlinedIcon style={
                        {
                          color: "#12b1ee",
                        }
                      }
                      /> </InputAdornment >
                    ),
                  }
                }
                value={
                  newPassword
                }
                onChange={
                  onChange
                }
              /> <TextField margin="normal"
                fullWidth name="repeatPassword"
                label="REPETIR CONTRASEÑA NUEVA"
                type="password"
                id="repeatPassword"
                autoComplete="current-password"
                style={
                  {
                    fontSize: "14px"
                  }
                }
                InputLabelProps={
                  {
                    style: {
                      fontSize: "14px"
                    }
                  }
                }
                InputProps={
                  {
                    style: {
                      fontSize: "14px"
                    },
                    startAdornment: (<InputAdornment position="start" >
                      <LockOutlinedIcon style={
                        {
                          color: "#12b1ee",
                        }
                      }
                      /> </InputAdornment >
                    ),
                  }
                }
                value={
                  repeatPassword
                }
                onChange={
                  onChange
                }
              /> {
                alert && < AlertMui message={
                  alert.msg
                }
                  type={
                    alert.category
                  }
                />} <Grid className={
                  classes.contentSubmit
                } > {
                  loading ? (<
                    CircularProgress />
                  ) : (<Button type="submit"
                    variant="contained"
                    color="primary"
                    className={
                      classes.submit
                    } >
                    CONFIRMAR CAMBIO </Button>
                    )
                } </Grid>
            </form >
          </Paper>
        </Grid >
      </Grid>
    </div>
  );
};

export default withRouter(ChangePassword);